import type { MouseEvent } from 'react'

// Only plain left clicks get hijacked for in-page updates; modified or
// middle clicks keep the anchor default, opening the href in a new tab.
export const isPlainLeftClick = (e: MouseEvent) =>
  e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
